import styled, { css } from "styled-components";
import { Style } from "../../styles";

const HeaderAction = styled.div<{
  type?: 'outline' | 'primary',
  starred?: boolean
  mobile?: boolean
}>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 32px;
  width: 32px;
  padding: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  background: #f8f8f7;
  color: #1a1a1a;
  cursor: pointer;
  border-radius: 50%;

  svg {
    width: 14px;
    height: 14px;
    min-width: 14px;
    min-height: 14px;
    fill: currentColor;
  }

  i {
    font-size: 14px;
    color: currentColor;
  }
  
  &:hover {
    background-color: #f0f1ef;
  }

  ${props => props.type === 'outline' && css`
    background: transparent;
  `}

  ${props => props.type === 'primary' && css`
    background: black;
    color: white;

    &:hover {
      background: #525251;
    }
  `}

  ${props => props.starred && css`
    svg {
      color: rgb(249, 198, 31);
      fill: rgb(249, 198, 31);
    }
  `}

  ${props => props.mobile && css`
    display: none;

    @media screen and (max-width: ${Style.breakpoints.SMALL}) {
      display: flex;
    }
  `}
`

export default HeaderAction